import styled from 'styled-components';

export const Container = styled.div`
  padding: 25px 50px;
  margin: 0 auto;
  width: 100%;
  min-height: calc(100vh - 148px);
    @media (max-width: 768px) {
        padding: 15px 15px;
    }
`;
